import { withManagedForm } from "@/application/components/admin/connections/managedForm";

export function editConnectionForm({ allowlistedInputs = [] }) {
  const form = {
    initChild() {
      this.comparatorJsonArraysRemovals =
        this.comparatorJsonArraysRemovals.bind(this);
      this.comparatorJsonArraysAnyChange =
        this.comparatorJsonArraysAnyChange.bind(this);
      this.comparatorStringAnyChange =
        this.comparatorStringAnyChange.bind(this);
      this.filterMultiSelectChange = this.filterMultiSelectChange.bind(this);
    },
    filterMultiSelectChange(_parent, value, name) {
      const fieldName = this.nameToKey(name);
      this[fieldName] = JSON.stringify(value);
      this.watch(this.nameToKey(name))(this[fieldName]);
    },

    comparatorJsonArraysRemovals(initialValue, currentValue) {
      try {
        return this.destructiveArrayComparator(
          JSON.parse(initialValue),
          JSON.parse(currentValue),
        );
      } catch (e) {
        return false;
      }
    },

    comparatorJsonArraysAnyChange(initialValue, currentValue) {
      try {
        const initial = JSON.parse(initialValue);
        const current = JSON.parse(currentValue);
        const initialSet = new Set(initial);
        const currentSet = new Set(current);
        // Return true if arrays are different in any way (additions or removals)
        if (initialSet.size !== currentSet.size) return true;
        return (
          [...initialSet].some((item) => !currentSet.has(item)) ||
          [...currentSet].some((item) => !initialSet.has(item))
        );
      } catch (e) {
        return false;
      }
    },

    comparatorStringAnyChange(initialValue, currentValue) {
      // Return true if the string value changed in any way
      return initialValue !== currentValue;
    },
  };

  return withManagedForm(
    { formRef: "editConnectionForm", allowlistedInputs },
    form,
  );
}
